import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { InlineButtonComponent, StatusBadgeComponent } from '@joii/design-system';
import { LucideMessageCircleHeart } from '@lucide/angular';
import { injectParams } from 'ngxtension/inject-params';
import { combineLatest } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { AppUpdateService } from 'src/shared/service-worker/app-update.service';
import { ChatDataStore } from 'src/shared/stores/chat/chat-data.store';
import { AuthenticationService } from 'src/shared/services/auth/auth_service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [InlineButtonComponent, StatusBadgeComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  router = inject(Router);
  activatedRoute = inject(ActivatedRoute);
  authenticationService = inject(AuthenticationService);
  /** Layout sits above `trial/:trial_doc_id`, so read the param from the full route tree. */
  trialId = injectParams.global('trial_doc_id');
  chatDataStore = inject(ChatDataStore);
  appUpdate = inject(AppUpdateService);
  messageCircleHeart = LucideMessageCircleHeart;
  /** Hide header on call page, report-issue/success route, or report-issue when query param hideheader is set */
  hidePage = toSignal(
    combineLatest([
      this.router.events.pipe(
        map(() => this.router.url),
        startWith(this.router.url)
      ),
      this.activatedRoute.queryParamMap.pipe(startWith(this.activatedRoute.snapshot.queryParamMap)),
    ]).pipe(
      map(([url, queryParams]) => {
        const onCall = url.includes('call');
        if (onCall) {
          return true;
        }
        const onReportIssueSuccess = url.includes('report-issue/success');
        if (onReportIssueSuccess) {
          return true;
        }
        const onReportIssue = url.includes('report-issue');
        const hideHeader = queryParams.get('hideheader');
        return onReportIssue && (hideHeader === 'true' || hideHeader === '');
      })
    ),
    { initialValue: false }
  );

  logout() {
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }
  reportIssue() {
    this.router.navigate(['/trial', this.trialId(), 'report-issue']);
  }
  joinChat() {
    this.router.navigate([
      '/trial',
      this.chatDataStore.latestIncompleteChat()?.trial_doc_id,
      'report-issue',
      'success',
    ]);
  }
}
